import React from 'react';
import { motion } from 'framer-motion';
import { HeadphonesIcon, BarChart3Icon, SettingsIcon, BadgeCheckIcon } from 'lucide-react';
import { Card } from './ui/Card';
export function SupportSection() {
  const supportFeatures = [{
    icon: HeadphonesIcon,
    title: 'Dedicated Support',
    description: 'Text or email us anytime. Real people respond fast—no ticket systems or waiting days for help.'
  }, {
    icon: BarChart3Icon,
    title: 'Monthly Performance Tracking',
    description: 'We monitor your response rates, bookings, and conversion metrics. You get a clear report every month.'
  }, {
    icon: SettingsIcon,
    title: 'Ongoing Optimization',
    description: "We make adjustments to improve results—tweaking responses, booking flows, and follow-ups based on what's working."
  }];
  return <section className="py-20 px-6 bg-gradient-to-br from-[var(--deep-teal)] to-[var(--jet-black)] text-white" data-id="element-249">
      <div className="max-w-6xl mx-auto" data-id="element-250">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-251">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-252">
            We Don't Just Set It and Forget It
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-253">
            Your success is our success. We actively manage, optimize, and
            support your system every month.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-254">
          {supportFeatures.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} data-id="element-255">
              <Card padding="lg" className="h-full bg-white/10 backdrop-blur-sm border border-white/20" data-id="element-256">
                <feature.icon className="w-12 h-12 text-[var(--viridia-green)] mb-4" data-id="element-257" />
                <h3 className="text-2xl font-bold mb-3" data-id="element-258">{feature.title}</h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-259">
                  {feature.description}
                </p>
              </Card>
            </motion.div>)}
        </div>

        {/* Yelp Partner Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="bg-white/10 backdrop-blur-sm border-2 border-[var(--viridia-green)] rounded-2xl p-8 md:p-12" data-id="element-260">
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-261">
            <div className="flex-shrink-0" data-id="element-262">
              <div className="w-24 h-24 bg-[var(--viridia-green)] rounded-full flex items-center justify-center" data-id="element-263">
                <BadgeCheckIcon className="w-16 h-16 text-white" data-id="element-264" />
              </div>
            </div>
            <div className="flex-grow text-center md:text-left" data-id="element-265">
              <h3 className="text-3xl font-bold mb-3" data-id="element-266">
                Official Yelp Ads Partner Agency
              </h3>
              <p className="text-xl text-gray-300 mb-4" data-id="element-267">
                We're certified Yelp partners. That means we can help you get
                better results from Yelp advertising.
              </p>
              <div className="grid sm:grid-cols-3 gap-4 text-sm" data-id="element-268">
                <div className="bg-white/5 rounded-lg p-4" data-id="element-269">
                  <p className="font-bold text-[var(--viridia-green)] mb-1" data-id="element-270">
                    Partner Discounts
                  </p>
                  <p className="text-gray-400" data-id="element-271">
                    Access exclusive Yelp ad pricing
                  </p>
                </div>
                <div className="bg-white/5 rounded-lg p-4" data-id="element-272">
                  <p className="font-bold text-[var(--viridia-green)] mb-1" data-id="element-273">
                    Smart Targeting
                  </p>
                  <p className="text-gray-400" data-id="element-274">
                    Reach the right customers in your area
                  </p>
                </div>
                <div className="bg-white/5 rounded-lg p-4" data-id="element-275">
                  <p className="font-bold text-[var(--viridia-green)] mb-1" data-id="element-276">
                    Performance Tracking
                  </p>
                  <p className="text-gray-400" data-id="element-277">
                    See exactly what's working and what's not
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}